<template>
  <div class="i-footer">
    <div class="inner">
      <div
        class="brand"
        aria-label="Realign, Inc. (Jobtest.org)"
      >
        <img
          :src="logo"
          alt="Jobtest logo"
        />
      </div>

      <h2 class="headline">Unlock the future you deserve.</h2>

      <nav
        class="links"
        aria-label="Legal links"
      >
        <a
          class="link"
          href="https://www.jobtest.org/terms-of-service"
          >Terms</a
        >
        <a
          class="link"
          href="https://www.jobtest.org/privacy-policy"
          >Privacy policy</a
        >
      </nav>

      <p class="copyright">Copyright © {{ new Date().getFullYear() }} | Realign, Inc. (Jobtest.org)</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import logo from "@/assets/logo/logo-white.svg"
</script>

<style scoped lang="scss">
.i-footer {
  position: absolute;
  background:
    linear-gradient(90deg, rgb(0 0 0 / 60%) 0%, rgb(0 0 0 / 60%) 100%), linear-gradient(90deg, #068eff 0%, #ab2af3 100%);
  color: white;
  left: 0;
  right: 0;
  width: 100%;

  .inner {
    max-width: 1100px;
    padding: 56px 16px 48px;
    margin: 0 auto;
    text-align: center;

    .brand {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      margin-bottom: 20px;
    }

    .headline {
      @include display-md;

      margin: 8px auto 28px;
      font-weight: 700;
      line-height: 1.2;

      @media (min-width: $breakpoint-lg) {
        @include display-lg;
      }
    }

    .links {
      display: inline-flex;
      align-items: center;
      gap: 20px;
      margin-bottom: 26px;
      color: #e7e7e7;

      .link {
        color: inherit;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .copyright {
      color: #e7e7e7;
      font-size: 14px;
      margin: 0;
    }
  }
}
</style>
